import { LeafInput } from "./input.component.js";
customElements.define("leaf-input", LeafInput);
export {
  LeafInput
};
//# sourceMappingURL=input.js.map
